<ul class="answer-type d-flex flex-row m-0" [class.flex-column]="flexDirection">
  @for (item of answers; track item; let i = $index) {
    <li [class.max-height]="item.input" [class.select-answer]="width == 'grid'">
      <input
        type="radio"
        id="{{ item.type }}{{ i }}"
        value="{{ item.type }}"
        [attr.name]="name"
        [value]="item.type"
        [checked]="selectedValue === item.value"
        (change)="onRadioChange(item.label)" />
      <label class="h4-bold spacing-12" for="{{ item.type }}{{ i }}">
        <div class="primary-100 w-100 d-flex align-items-start flex-column spacing-8">
          <div class="primary-100 d-flex align-items-center spacing-12">
            @if (item.numbring) {
              <app-badges
                [withIcon]="false"
                Type="tag"
                IconType="no_icon"
                label="{{ item.badgelabel }}"
                [ellipsis]="true"></app-badges>
            }
            {{ item.label }}
          </div>
          @if (item.input) {
            <app-inputs
              class="w-100"
              Label=""
              [type]="'text'"
              [active]="false"
              [dropdown]="false"
              [stepCounter]="false"
              (onChange)="onInputChange($event)"
              [placeholder]="item.inputPlaceholder"
              [prefix]="false"
              [suffix]="false"
              [warn]="false"
              [state]="'default'">
            </app-inputs>
          }
        </div>
      </label>
    </li>
  }
</ul>
